import _slicedToArray from "/opt/buildhome/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/opt/buildhome/repo/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/opt/buildhome/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/opt/buildhome/repo/node_modules/@babel/runtime/regenerator/index.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return a;
};

var __objRest = function __objRest(source, exclude) {
  var target = {};

  for (var prop in source) {
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  }

  if (source != null && __getOwnPropSymbols) {
    var _iterator2 = _createForOfIteratorHelper(__getOwnPropSymbols(source)),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var prop = _step2.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }

  return target;
};

import * as React from "react";

var isArray = function isArray(thing) {
  return Array.isArray(thing);
};

var asArray = function asArray(value) {
  return isArray(value) ? value : [value];
};

var Queue = function Queue(initialItems) {
  var add = function add(steps) {
    _queue = _queue.concat(asArray(steps));
    return this;
  };

  var set = function set(index, item) {
    _queue[index] = item;
  };

  var reset = function reset() {
    _queue = _queue.map(function (item) {
      delete item.done;
      return item;
    });
  };

  var wipe = function wipe() {
    _queue = [];
    add(initialItems);
  };

  var getItems = function getItems() {
    var all = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return _queue.filter(function (i) {
      return all || !i.done;
    });
  };

  var markDone = function markDone(index) {
    _queue[index].done = true;
  };

  var _queue = [];
  add(initialItems);
  return {
    add: add,
    set: set,
    reset: reset,
    wipe: wipe,
    getItems: getItems,
    markDone: markDone
  };
};

var toArray = function toArray(val) {
  return Array.from(val);
};

var createTextNode = function createTextNode(content) {
  return document.createTextNode(content);
};

var expandTextNodes = function expandTextNodes(element) {
  _toConsumableArray(element.childNodes).forEach(function (child) {
    if (child.nodeValue) {
      _toConsumableArray(child.nodeValue).forEach(function (c) {
        child.parentNode.insertBefore(createTextNode(c), child);
      });

      child.remove();
      return;
    }

    expandTextNodes(child);
  });

  return element;
};

var getParsedBody = function getParsedBody(content) {
  var doc = document.implementation.createHTMLDocument();
  doc.body.innerHTML = content;
  return expandTextNodes(doc.body);
};

var DATA_ATTRIBUTE = "data-typeit-id";
var CURSOR_CLASS = "ti-cursor";
var START = "START";
var END = "END";
var DEFAULT_STATUSES = {
  started: false,
  completed: false,
  frozen: false,
  destroyed: false
};
var DEFAULT_OPTIONS = {
  breakLines: true,
  cursor: true,
  cursorChar: "|",
  cursorSpeed: 1e3,
  deleteSpeed: null,
  html: true,
  lifeLike: true,
  loop: false,
  loopDelay: 750,
  nextStringDelay: 750,
  speed: 100,
  startDelay: 250,
  startDelete: false,
  strings: [],
  waitUntilVisible: false,
  beforeString: function beforeString() {},
  afterString: function afterString() {},
  beforeStep: function beforeStep() {},
  afterStep: function afterStep() {},
  afterComplete: function afterComplete() {}
};

function walkElementNodes(element) {
  var shouldReverse = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var walker = document.createTreeWalker(element, NodeFilter.SHOW_ALL, {
    acceptNode: function acceptNode(node) {
      var _a;

      return ((_a = node == null ? void 0 : node.classList) == null ? void 0 : _a.contains(CURSOR_CLASS)) ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT;
    }
  });
  var nextNode;
  var nodes = [];

  while (nextNode = walker.nextNode()) {
    nextNode.originalParent = nextNode.parentNode;
    nodes.push(nextNode);
  }

  return shouldReverse ? nodes.reverse() : nodes;
}

function chunkStringAsHtml(string) {
  return walkElementNodes(getParsedBody(string));
}

function maybeChunkStringAsHtml(str) {
  var asHtml = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return asHtml ? chunkStringAsHtml(str) : toArray(str).map(createTextNode);
}

var createElement = function createElement(el) {
  return document.createElement(el);
};

var appendStyleBlock = function appendStyleBlock(styles) {
  var id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  var styleBlock = createElement("style");
  styleBlock.id = id;
  styleBlock.appendChild(createTextNode(styles));
  document.head.appendChild(styleBlock);
};

var isNumber = function isNumber(value) {
  return Number.isInteger(value);
};

var select = function select(selector) {
  var element = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;
  var all = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return element["querySelector".concat(all ? "All" : "")](selector);
};

var isInput = function isInput(el) {
  return "value" in el;
};

var getAllChars = function getAllChars(element) {
  if (isInput(element)) {
    return toArray(element.value);
  }

  return walkElementNodes(element, true).filter(function (c) {
    return !(c.childNodes.length > 0);
  });
};

var calculateStepsToSelector = function calculateStepsToSelector(selector, element) {
  var to = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : START;
  var isMovingToLast = new RegExp(END, "i").test(to);
  var selectedElement = selector ? select(selector, element) : element;
  var selectedElementNodes = walkElementNodes(selectedElement, true);
  var selectedElementFirstChild = selectedElementNodes[0];
  var selectedElementLastChild = selectedElementNodes[selectedElementNodes.length - 1];
  var isMovingToEndOfRootElement = isMovingToLast && !selector;
  var childIndex = isMovingToEndOfRootElement ? 0 : getAllChars(element).findIndex(function (character) {
    return character.isSameNode(isMovingToLast ? selectedElementFirstChild : selectedElementLastChild);
  });
  if (isMovingToLast) childIndex--;
  return childIndex + 1;
};

var calculateCursorSteps = function calculateCursorSteps(_ref) {
  var el = _ref.el,
      move = _ref.move,
      cursorPos = _ref.cursorPos,
      to = _ref.to;

  if (isNumber(move)) {
    return move * -1;
  }

  var childIndex = calculateStepsToSelector(move, el, to);
  return childIndex - cursorPos;
};

var calculateDelay = function calculateDelay(delayArg) {
  if (!isArray(delayArg)) {
    delayArg = [delayArg / 2, delayArg / 2];
  }

  return delayArg;
};

var randomInRange = function randomInRange(value, range2) {
  return Math.abs(Math.random() * (value + range2 - (value - range2)) + (value - range2));
};

var range = function range(val) {
  return val / 2;
};

function calculatePace(options) {
  var speed = options.speed,
      deleteSpeed = options.deleteSpeed,
      lifeLike = options.lifeLike;
  deleteSpeed = deleteSpeed !== null ? deleteSpeed : speed / 3;
  return lifeLike ? [randomInRange(speed, range(speed)), randomInRange(deleteSpeed, range(deleteSpeed))] : [speed, deleteSpeed];
}

var destroyTimeouts = function destroyTimeouts(timeouts) {
  timeouts.forEach(function (timeout) {
    return clearTimeout(timeout);
  });
  return [];
};

var generateHash = function generateHash() {
  return Math.random().toString().substring(2, 9);
};

var fireWhenVisible = function fireWhenVisible(element, func) {
  var observer = new IntersectionObserver(function (entries, observer2) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        func();
        observer2.unobserve(element);
      }
    });
  }, {
    threshold: 1
  });
  observer.observe(element);
};

var handleFunctionalArg = function handleFunctionalArg(arg) {
  return typeof arg === "function" ? arg() : arg;
};

var isBodyElement = function isBodyElement(node) {
  return (node == null ? void 0 : node.tagName) === "BODY";
};

var insertIntoElement = function insertIntoElement(originalTarget, character) {
  if (isInput(originalTarget)) {
    originalTarget.value = "".concat(originalTarget.value).concat(character.textContent);
    return;
  }

  character.innerHTML = "";
  var target = isBodyElement(character.originalParent) ? originalTarget : character.originalParent || originalTarget;
  target.insertBefore(character, select("." + CURSOR_CLASS, target) || null);
};

var updateCursorPosition = function updateCursorPosition(steps, cursorPosition, printedCharacters) {
  return Math.min(Math.max(cursorPosition + steps, 0), printedCharacters.length);
};

var merge = function merge(originalObj, newObj) {
  return Object.assign({}, originalObj, newObj);
};

var removeNode = function removeNode(node) {
  if (!node) return;
  var nodeParent = node.parentNode;
  var nodeToRemove = nodeParent.childNodes.length > 1 ? node : nodeParent;
  nodeToRemove.remove();
};

var repositionCursor = function repositionCursor(element, allChars, newCursorPosition) {
  var nodeToInsertBefore = allChars[newCursorPosition - 1];
  var cursor = select(".".concat(CURSOR_CLASS), element);
  element = (nodeToInsertBefore == null ? void 0 : nodeToInsertBefore.parentNode) || element;
  element.insertBefore(cursor, nodeToInsertBefore || null);
};

function selectorToElement(thing) {
  return typeof thing === "string" ? select(thing) : thing;
}

var isNonVoidElement = function isNonVoidElement(el) {
  return /<(.+)>(.*?)<\/(.+)>/.test(el.outerHTML);
};

var wait = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(callback, delay, timeouts) {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", new Promise(function (resolve) {
              var cb = /*#__PURE__*/function () {
                var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return callback();

                        case 2:
                          resolve();

                        case 3:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }));

                return function cb() {
                  return _ref3.apply(this, arguments);
                };
              }();

              timeouts.push(setTimeout(cb, delay));
            }));

          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function wait(_x, _x2, _x3) {
    return _ref2.apply(this, arguments);
  };
}();

var cursorFontStyles = {
  "font-family": "",
  "font-weight": "",
  "font-size": "",
  "font-style": "",
  "line-height": "",
  color: "",
  "margin-left": "-.125em",
  "margin-right": ".125em"
};

var setCursorStyles = function setCursorStyles(id, options, element) {
  var rootSelector = "[".concat(DATA_ATTRIBUTE, "='").concat(id, "']");
  var cursorSelector = "".concat(rootSelector, " .").concat(CURSOR_CLASS);
  var computedStyles = getComputedStyle(element);
  var customProperties = Object.entries(cursorFontStyles).reduce(function (accumulator, _ref4) {
    var _ref5 = _slicedToArray(_ref4, 2),
        item = _ref5[0],
        value = _ref5[1];

    return "".concat(accumulator, " ").concat(item, ": var(--ti-cursor-").concat(item, ", ").concat(value || computedStyles[item], ");");
  }, "");
  appendStyleBlock("@keyframes blink-".concat(id, " { 0% {opacity: 0} 49% {opacity: 0} 50% {opacity: 1} } ").concat(cursorSelector, " { display: inline; letter-spacing: -1em; ").concat(customProperties, " animation: blink-").concat(id, " ").concat(options.cursorSpeed / 1e3, "s infinite; } ").concat(cursorSelector, ".with-delay { animation-delay: 500ms; } ").concat(cursorSelector, ".disabled { animation: none; }"), id);
};

function TypeIt$1(element) {
  var _this = this;

  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _wait = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(callback, delay) {
      var silent,
          _args3 = arguments;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              silent = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : false;

              if (!_statuses.frozen) {
                _context3.next = 4;
                break;
              }

              _context3.next = 4;
              return new Promise(function (resolve) {
                _this.unfreeze = function () {
                  _statuses.frozen = false;
                  resolve();
                };
              });

            case 4:
              _context3.t0 = silent;

              if (_context3.t0) {
                _context3.next = 8;
                break;
              }

              _context3.next = 8;
              return _opts.beforeStep(_this);

            case 8:
              _context3.next = 10;
              return wait(callback, delay, _timeouts);

            case 10:
              _context3.t1 = silent;

              if (_context3.t1) {
                _context3.next = 14;
                break;
              }

              _context3.next = 14;
              return _opts.afterStep(_this);

            case 14:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function _wait(_x4, _x5) {
      return _ref6.apply(this, arguments);
    };
  }();

  var _elementIsInput = function _elementIsInput() {
    return isInput(_element);
  };

  var _getPace = function _getPace(index) {
    return calculatePace(_opts)[index];
  };

  var _getAllChars = function _getAllChars() {
    return getAllChars(_element);
  };

  var _getActionPace = function _getActionPace(instant) {
    var paceIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    return instant ? _getPace(paceIndex) : 0;
  };

  var _maybeAppendPause = function _maybeAppendPause() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var delay = opts["delay"];
    delay && _queue.add(function () {
      return _pause(delay);
    });
  };

  var _queueAndReturn = function _queueAndReturn(steps, opts) {
    _queue.add(steps);

    _maybeAppendPause(opts);

    return _this;
  };

  var _generateTemporaryOptionQueueItems = function _generateTemporaryOptionQueueItems() {
    var newOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return [function () {
      return _options(newOptions);
    }, function () {
      return _options(_opts);
    }];
  };

  var _addSplitPause = function _addSplitPause(items) {
    var delay = _opts.nextStringDelay;

    _queue.add([function () {
      return _pause(delay[0]);
    }].concat(_toConsumableArray(items), [function () {
      return _pause(delay[1]);
    }]));
  };

  var _setUpCursor = function _setUpCursor() {
    if (_elementIsInput()) {
      return;
    }

    var cursor = createElement("span");
    cursor.className = CURSOR_CLASS;

    if (!_shouldRenderCursor) {
      cursor.style.visibility = "hidden";
      return cursor;
    }

    cursor.innerHTML = getParsedBody(_opts.cursorChar).innerHTML;
    return cursor;
  };

  var _attachCursor = /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              !_elementIsInput() && _element.appendChild(_cursor);
              _shouldRenderCursor && setCursorStyles(_id, _opts, _element);

            case 2:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function _attachCursor() {
      return _ref7.apply(this, arguments);
    };
  }();

  var _disableCursorBlink = function _disableCursorBlink(shouldDisable) {
    if (_shouldRenderCursor) {
      _cursor.classList.toggle("disabled", shouldDisable);

      _cursor.classList.toggle("with-delay", !shouldDisable);
    }
  };

  var _generateQueue = function _generateQueue() {
    var strings = _opts.strings.filter(function (string) {
      return !!string;
    });

    strings.forEach(function (string, index) {
      var chars = maybeChunkStringAsHtml(string, _opts.html);

      _queue.add(function () {
        return _type({
          chars: chars
        });
      });

      if (index + 1 === strings.length) {
        return;
      }

      var splitPauseArgs = [_opts.breakLines ? function () {
        return _type({
          chars: [createElement("BR")],
          silent: true
        });
      } : function () {
        return _delete({
          num: chars.length
        });
      }];

      _addSplitPause(splitPauseArgs);
    });
  };

  var _prepLoop = /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(delay) {
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.t0 = _cursorPosition;

              if (!_context5.t0) {
                _context5.next = 4;
                break;
              }

              _context5.next = 4;
              return _move({
                value: _cursorPosition
              });

            case 4:
              _queue.reset();

              _queue.set(0, function () {
                return _pause(delay);
              });

              _context5.next = 8;
              return _delete({
                num: null
              });

            case 8:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function _prepLoop(_x6) {
      return _ref8.apply(this, arguments);
    };
  }();

  var _maybePrependHardcodedStrings = function _maybePrependHardcodedStrings(strings) {
    var existingMarkup = _element.innerHTML;

    if (!existingMarkup) {
      return strings;
    }

    _element.innerHTML = "";

    if (_opts.startDelete) {
      _element.innerHTML = existingMarkup;
      expandTextNodes(_element);

      _addSplitPause([function () {
        return _delete({
          num: null
        });
      }]);

      return strings;
    }

    var hardCodedStrings = existingMarkup.trim().split(/<br(?:\s*?)(?:\/)?>/);
    return hardCodedStrings.concat(strings);
  };

  var _fire = /*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
      var queueItems, i, delay;
      return _regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              _statuses.started = true;
              queueItems = _queue.getItems();
              _context7.prev = 2;
              i = 0;

            case 4:
              if (!(i < queueItems.length)) {
                _context7.next = 12;
                break;
              }

              _context7.next = 7;
              return queueItems[i]();

            case 7:
              _queue.markDone(i);

              _disableCursorBlink(false);

            case 9:
              i++;
              _context7.next = 4;
              break;

            case 12:
              _statuses.completed = true;
              _context7.next = 15;
              return _opts.afterComplete(_this);

            case 15:
              if (_opts.loop) {
                _context7.next = 17;
                break;
              }

              throw "";

            case 17:
              delay = _opts.loopDelay;

              _wait( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
                return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                  while (1) {
                    switch (_context6.prev = _context6.next) {
                      case 0:
                        _context6.next = 2;
                        return _prepLoop(delay[0]);

                      case 2:
                        _fire();

                      case 3:
                      case "end":
                        return _context6.stop();
                    }
                  }
                }, _callee6);
              })), delay[1]);

              _context7.next = 23;
              break;

            case 21:
              _context7.prev = 21;
              _context7.t0 = _context7["catch"](2);

            case 23:
              return _context7.abrupt("return", _this);

            case 24:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, null, [[2, 21]]);
    }));

    return function _fire() {
      return _ref9.apply(this, arguments);
    };
  }();

  var _pause = function _pause() {
    var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    return _wait(function () {}, time);
  };

  var _move = /*#__PURE__*/function () {
    var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(_ref11) {
      var value, _ref11$to, to, _ref11$instant, instant, numberOfSteps, moveCursor;

      return _regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              value = _ref11.value, _ref11$to = _ref11.to, to = _ref11$to === void 0 ? START : _ref11$to, _ref11$instant = _ref11.instant, instant = _ref11$instant === void 0 ? false : _ref11$instant;

              _disableCursorBlink(true);

              numberOfSteps = calculateCursorSteps({
                el: _element,
                move: value,
                cursorPos: _cursorPosition,
                to: to
              });

              moveCursor = function moveCursor() {
                _cursorPosition = updateCursorPosition(numberOfSteps < 0 ? -1 : 1, _cursorPosition, _getAllChars());
                repositionCursor(_element, _getAllChars(), _cursorPosition);
              };

              _context9.next = 6;
              return _wait( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
                var i;
                return _regeneratorRuntime.wrap(function _callee8$(_context8) {
                  while (1) {
                    switch (_context8.prev = _context8.next) {
                      case 0:
                        i = 0;

                      case 1:
                        if (!(i < Math.abs(numberOfSteps))) {
                          _context8.next = 11;
                          break;
                        }

                        if (!instant) {
                          _context8.next = 6;
                          break;
                        }

                        moveCursor();
                        _context8.next = 8;
                        break;

                      case 6:
                        _context8.next = 8;
                        return _wait(moveCursor, _getPace(0));

                      case 8:
                        i++;
                        _context8.next = 1;
                        break;

                      case 11:
                      case "end":
                        return _context8.stop();
                    }
                  }
                }, _callee8);
              })), _getActionPace(instant));

            case 6:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9);
    }));

    return function _move(_x7) {
      return _ref12.apply(this, arguments);
    };
  }();

  var _type = function _type(_ref14) {
    var chars = _ref14.chars,
        _ref14$silent = _ref14.silent,
        silent = _ref14$silent === void 0 ? false : _ref14$silent,
        _ref14$instant = _ref14.instant,
        instant = _ref14$instant === void 0 ? false : _ref14$instant;

    _disableCursorBlink(true);

    return _wait( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
      var insert, _iterator3, _step3, _loop;

      return _regeneratorRuntime.wrap(function _callee10$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              insert = function insert(character) {
                return insertIntoElement(_element, character);
              };

              _context11.t0 = silent;

              if (_context11.t0) {
                _context11.next = 5;
                break;
              }

              _context11.next = 5;
              return _opts.beforeString(chars, _this);

            case 5:
              _iterator3 = _createForOfIteratorHelper(chars);
              _context11.prev = 6;
              _loop = /*#__PURE__*/_regeneratorRuntime.mark(function _loop() {
                var char;
                return _regeneratorRuntime.wrap(function _loop$(_context10) {
                  while (1) {
                    switch (_context10.prev = _context10.next) {
                      case 0:
                        char = _step3.value;

                        if (!(instant || isNonVoidElement(char))) {
                          _context10.next = 5;
                          break;
                        }

                        insert(char);
                        _context10.next = 7;
                        break;

                      case 5:
                        _context10.next = 7;
                        return _wait(function () {
                          return insert(char);
                        }, _getPace(0));

                      case 7:
                      case "end":
                        return _context10.stop();
                    }
                  }
                }, _loop);
              });

              _iterator3.s();

            case 9:
              if ((_step3 = _iterator3.n()).done) {
                _context11.next = 13;
                break;
              }

              return _context11.delegateYield(_loop(), "t1", 11);

            case 11:
              _context11.next = 9;
              break;

            case 13:
              _context11.next = 18;
              break;

            case 15:
              _context11.prev = 15;
              _context11.t2 = _context11["catch"](6);

              _iterator3.e(_context11.t2);

            case 18:
              _context11.prev = 18;

              _iterator3.f();

              return _context11.finish(18);

            case 21:
              _context11.t3 = silent;

              if (_context11.t3) {
                _context11.next = 25;
                break;
              }

              _context11.next = 25;
              return _opts.afterString(chars, _this);

            case 25:
            case "end":
              return _context11.stop();
          }
        }
      }, _callee10, null, [[6, 15, 18, 21]]);
    })), _getActionPace(instant), true);
  };

  var _options = /*#__PURE__*/function () {
    var _ref16 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(opts) {
      return _regeneratorRuntime.wrap(function _callee11$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              _opts = merge(_opts, opts);
              return _context12.abrupt("return");

            case 2:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee11);
    }));

    return function _options(_x8) {
      return _ref16.apply(this, arguments);
    };
  }();

  var _empty = /*#__PURE__*/function () {
    var _ref17 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
      return _regeneratorRuntime.wrap(function _callee12$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              if (!_elementIsInput()) {
                _context13.next = 3;
                break;
              }

              _element.value = "";
              return _context13.abrupt("return");

            case 3:
              _getAllChars().forEach(function (n) {
                removeNode(n);
              });

              return _context13.abrupt("return");

            case 5:
            case "end":
              return _context13.stop();
          }
        }
      }, _callee12);
    }));

    return function _empty() {
      return _ref17.apply(this, arguments);
    };
  }();

  var _delete = /*#__PURE__*/function () {
    var _ref19 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(_ref18) {
      var _ref18$num, num, _ref18$instant, instant, _ref18$to, to;

      return _regeneratorRuntime.wrap(function _callee14$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              _ref18$num = _ref18.num, num = _ref18$num === void 0 ? null : _ref18$num, _ref18$instant = _ref18.instant, instant = _ref18$instant === void 0 ? false : _ref18$instant, _ref18$to = _ref18.to, to = _ref18$to === void 0 ? START : _ref18$to;

              _disableCursorBlink(true);

              _context15.next = 4;
              return _wait( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13() {
                var rounds, deleteIt, i;
                return _regeneratorRuntime.wrap(function _callee13$(_context14) {
                  while (1) {
                    switch (_context14.prev = _context14.next) {
                      case 0:
                        rounds = function () {
                          if (num === null) {
                            return _getAllChars().length;
                          }

                          if (isNumber(num)) {
                            return num;
                          }

                          return calculateCursorSteps({
                            el: _element,
                            move: num,
                            cursorPos: _cursorPosition,
                            to: to
                          });
                        }();

                        deleteIt = function deleteIt() {
                          var allChars = _getAllChars();

                          if (!allChars.length) return;

                          if (_elementIsInput()) {
                            _element.value = _element.value.slice(0, -1);
                          } else {
                            removeNode(allChars[_cursorPosition]);
                          }
                        };

                        i = 0;

                      case 3:
                        if (!(i < rounds)) {
                          _context14.next = 13;
                          break;
                        }

                        if (!instant) {
                          _context14.next = 8;
                          break;
                        }

                        deleteIt();
                        _context14.next = 10;
                        break;

                      case 8:
                        _context14.next = 10;
                        return _wait(deleteIt, _getPace(1));

                      case 10:
                        i++;
                        _context14.next = 3;
                        break;

                      case 13:
                      case "end":
                        return _context14.stop();
                    }
                  }
                }, _callee13);
              })), _getActionPace(instant, 1));

            case 4:
              if (!(num === null && _getAllChars().length - 1 > 0)) {
                _context15.next = 7;
                break;
              }

              _context15.next = 7;
              return _delete({
                num: null
              });

            case 7:
            case "end":
              return _context15.stop();
          }
        }
      }, _callee14);
    }));

    return function _delete(_x9) {
      return _ref19.apply(this, arguments);
    };
  }();

  this.break = function (actionOpts) {
    return _queueAndReturn(function () {
      return _type({
        chars: [createElement("BR")],
        silent: true
      });
    }, actionOpts);
  };

  this.delete = function () {
    var numCharacters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var actionOpts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    numCharacters = handleFunctionalArg(numCharacters);

    var bookEndQueueItems = _generateTemporaryOptionQueueItems(actionOpts);

    var num = numCharacters;
    var instant = actionOpts.instant,
        to = actionOpts.to;
    return _queueAndReturn([bookEndQueueItems[0], function () {
      return _delete({
        num: num,
        instant: instant,
        to: to
      });
    }, bookEndQueueItems[1]], actionOpts);
  };

  this.empty = function () {
    var actionOpts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return _queueAndReturn(_empty, actionOpts);
  };

  this.exec = function (func, actionOpts) {
    var bookEndQueueItems = _generateTemporaryOptionQueueItems(actionOpts);

    return _queueAndReturn([bookEndQueueItems[0], func, bookEndQueueItems[1]], actionOpts);
  };

  this.move = function (movementArg) {
    var actionOpts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    movementArg = handleFunctionalArg(movementArg);

    var bookEndQueueItems = _generateTemporaryOptionQueueItems(actionOpts);

    var instant = actionOpts.instant,
        to = actionOpts.to;
    var moveArgs = {
      value: movementArg === null ? "" : movementArg,
      to: to,
      instant: instant
    };
    return _queueAndReturn([bookEndQueueItems[0], function () {
      return _move(moveArgs);
    }, bookEndQueueItems[1]], actionOpts);
  };

  this.options = function (opts) {
    opts = handleFunctionalArg(opts);
    return _queueAndReturn(function () {
      return _options(opts);
    }, opts);
  };

  this.pause = function (milliseconds) {
    var actionOpts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return _queueAndReturn(function () {
      return _pause(handleFunctionalArg(milliseconds));
    }, actionOpts);
  };

  this.type = function (string) {
    var actionOpts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    string = handleFunctionalArg(string);

    var bookEndQueueItems = _generateTemporaryOptionQueueItems(actionOpts);

    var chars = maybeChunkStringAsHtml(string, _opts.html);
    var instant = actionOpts.instant;
    var itemsToQueue = [bookEndQueueItems[0], function () {
      return _type({
        chars: chars,
        instant: instant
      });
    }, bookEndQueueItems[1]];
    return _queueAndReturn(itemsToQueue, actionOpts);
  };

  this.is = function (key) {
    return _statuses[key];
  };

  this.destroy = function () {
    var shouldRemoveCursor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    _timeouts = destroyTimeouts(_timeouts);
    handleFunctionalArg(shouldRemoveCursor) && removeNode(_cursor);
    _statuses.destroyed = true;
  };

  this.freeze = function () {
    _statuses.frozen = true;
  };

  this.unfreeze = function () {};

  this.reset = function (rebuild) {
    !this.is("destroyed") && this.destroy();

    if (rebuild) {
      _queue.wipe();

      rebuild(this);
    } else {
      _queue.reset();
    }

    _cursorPosition = 0;

    for (var property in _statuses) {
      _statuses[property] = false;
    }

    _element[_elementIsInput() ? "value" : "innerHTML"] = "";
    return this;
  };

  this.go = function () {
    if (_statuses.started) {
      return this;
    }

    _attachCursor();

    if (!_opts.waitUntilVisible) {
      _fire();

      return this;
    }

    fireWhenVisible(_element, _fire.bind(this));
    return this;
  };

  this.getQueue = function () {
    return _queue;
  };

  this.getOptions = function () {
    return _opts;
  };

  this.updateOptions = function (options2) {
    return _options(options2);
  };

  this.getElement = function () {
    return _element;
  };

  var _element = selectorToElement(element);

  var _timeouts = [];
  var _cursorPosition = 0;

  var _statuses = merge({}, DEFAULT_STATUSES);

  var _opts = merge(DEFAULT_OPTIONS, options);

  _opts = merge(_opts, {
    html: !_elementIsInput() && _opts.html,
    nextStringDelay: calculateDelay(_opts.nextStringDelay),
    loopDelay: calculateDelay(_opts.loopDelay)
  });

  var _id = generateHash();

  var _queue = Queue([function () {
    return _pause(_opts.startDelay);
  }]);

  _element.dataset.typeitId = _id;
  appendStyleBlock("[".concat(DATA_ATTRIBUTE, "]:before {content: '.'; display: inline-block; width: 0; visibility: hidden;}"));

  var _shouldRenderCursor = _opts.cursor && !_elementIsInput();

  var _cursor = _setUpCursor();

  _opts.strings = _maybePrependHardcodedStrings(asArray(_opts.strings));

  if (_opts.strings.length) {
    _generateQueue();
  }
}

var useRef = React.useRef,
    useEffect = React.useEffect,
    useState = React.useState;
var defaultProps = {
  as: "span",
  options: {},
  getBeforeInit: function getBeforeInit(instance) {
    return instance;
  },
  getAfterInit: function getAfterInit(instance) {
    return instance;
  }
};

var TypeIt = function TypeIt(props) {
  var elementRef = useRef(null);
  var instanceRef = useRef(null);

  var _a = props,
      options = _a.options,
      as = _a.as,
      children = _a.children,
      getBeforeInit = _a.getBeforeInit,
      getAfterInit = _a.getAfterInit,
      remainingProps = __objRest(_a, ["options", "as", "children", "getBeforeInit", "getAfterInit"]);

  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      shouldShowChildren = _useState2[0],
      setShouldShowChildren = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      instanceOptions = _useState4[0],
      setInstanceOptions = _useState4[1];

  var DynamicElement = as;

  function calculateOptions() {
    var optionsClone = Object.assign({}, options);

    if (children && elementRef.current) {
      optionsClone.strings = elementRef.current.innerHTML;
    }

    setInstanceOptions(optionsClone);
  }

  function generateNewInstance() {
    instanceRef.current = new TypeIt$1(elementRef.current, instanceOptions);
    instanceRef.current = getBeforeInit(instanceRef.current);
    instanceRef.current.go();
    instanceRef.current = getAfterInit(instanceRef.current);
  }

  useEffect(function () {
    calculateOptions();
    setShouldShowChildren(false);
  }, [options]);
  useEffect(function () {
    var _a2;

    if (!instanceOptions) return;
    ((_a2 = instanceRef.current) == null ? void 0 : _a2.updateOptions(instanceOptions)) || generateNewInstance();
  }, [instanceOptions]);
  useEffect(function () {
    return function () {
      var _a2;

      return (_a2 = instanceRef.current) == null ? void 0 : _a2.destroy();
    };
  }, []);
  return /* @__PURE__ */React.createElement(DynamicElement, __spreadValues({
    ref: elementRef,
    children: shouldShowChildren ? children : null,
    style: {
      opacity: shouldShowChildren ? 0 : 1
    }
  }, remainingProps));
};

TypeIt.defaultProps = defaultProps;
export { TypeIt as default };